app.service('deliveryInvoiceDetails', function (orderClass, orderConfig, vies, regon, companyName, select, validate, broker) {

	let $self, $taxIdTypeBoxes, $vatUe, $nip, $zipCode, $idNumber, $numberIdCountryCode, $vatUeCountryCode, $countryCode, $companyName, $userName, $invoiceAddress,
		$taxIdentifierSelector, $toggleOtherInvoiceReceiver, $toggleInvoiceDataOther, $toggleInvoiceDataUser;
	let $toggleTaxPayerRoleJst, $toggleTaxPayerRoleGrv;
	let config;
	let isOneInit = false;

	function init($deliveryForm) {
		config = orderConfig.getData();
		setElements($deliveryForm);
		setEvents($deliveryForm);
	}

	function setElements($deliveryForm) {
		$self = $deliveryForm.find('#invoice-section');
		$toggleOtherInvoiceReceiver = $deliveryForm.find('#toggle-invoice-details');
		$taxIdTypeBoxes = $self.find('.tax-id-type-box');
		$zipCode = $self.find('#invoice-zip-code');
		$vatUe = $self.find('#invoice-vat-ue');
		$nip = $self.find('#invoice-nip');
		$idNumber = $self.find('#invoice-id-number');
		$numberIdCountryCode = $self.find('#invoice-number-id-country-code');
		$vatUeCountryCode = $self.find('#invoice-vat-ue-country-code');
		$countryCode = $self.find('#invoice-country-code');
		$companyName = $self.find('#invoice-company-name-textarea');
		$userName = $self.find('#invoice-surname, #invoice-firstname');
		$invoiceAddress = $self.find('.invoice-address').find('input:not(#invoice-flat-number), textarea');
		$taxIdentifierSelector = $self.find('#invoice-tax-identifier-selector');
		$toggleTaxPayerRoleJst = $self.find('#toggle-tax-payer-role-jst');
		$toggleTaxPayerRoleGrv = $self.find('#toggle-tax-payer-role-grv');
		$toggleInvoiceDataUser = $deliveryForm.find('input[name=toggle-invoice-data][value=false]');
		$toggleInvoiceDataOther = $deliveryForm.find('input[name=toggle-invoice-data][value=true]');
	}

	function setEvents($form) {
		$('input[type=checkbox].js-toggle-invoice-data-checkbox', $form).on('click', function () {
			$('input[type=radio].js-toggle-invoice-data[value=' + $(this).prop('checked') + ']', $form).trigger('click');
		});
		// "Jak moje dane (podane powyżej)" / "Inne dane do faktury"
		$('input[type=radio].js-toggle-invoice-data', $form).on('click', function () {
			const showInvoiceData = $(this).val() !== "false";
			toggleInvoiceData(showInvoiceData);
		});

		$toggleTaxPayerRoleJst.on('change', function handleToggleTaxPayerRoleJstChange() {
			const checked = $(this).is(':checked');
			toggleTaxPayerRoleJstChange(checked);
			render();
		});
		$toggleTaxPayerRoleGrv.on('change', function handleToggleTaxPayerRoleGrvChange() {
			const checked = $(this).is(':checked');
			toggleTaxPayerRoleGrvChange(checked);
			render();
		});

		$taxIdentifierSelector.on('change', function () {
			config.deliveryInfo.invoiceTaxIdType = $(this).val();
			validate.element($(this), $form);
			onTaxIdentifierChange();
			broker.trigger('DELIVERY_INVOICE_TAX_ID_TYPE_CHANGED');
		});

		$toggleOtherInvoiceReceiver.on('click', function handleOtherInvoiceReceiverClick() {
			config.deliveryInfo.invoiceNeeded = $(this).is(":checked");

			broker.trigger('DELIVERY_OTHER_INVOICE_RECEIVER_CHANGED');
			render();
		});

		$numberIdCountryCode.on('change', function () {
			validate.element($(this), $form);
		});

		$countryCode.on('change', function () {
			validate.element($countryCode, $form);
			if ($zipCode.val().length) {
				validate.element($zipCode, $form);
			}
			handleInvoiceAddressCountryChange();
		});

		if ($countryCode.val() === 'PL') {
			$.cityAutocomplete('#invoice-zip-code', '#invoice-city-name', config.streetValidateEnable ? '#invoice-street' : false);
		}

		$('#invoice-id-number-div').on('input', function () {
			$idNumber.val($(this).text());
			validate.element($idNumber, $form);
		});

		companyName.init('invoice-company-name');

		regon.init({
			$country: $countryCode,
			$box: $self.find('.regon-box'),
			$nip: $('#invoice-nip'),
			$companyName: $('#invoice-company-name-textarea-div'),
			$city: $('#invoice-city-name'),
			$street: $('#invoice-street'),
			$houseNumber: $('#invoice-house-number'),
			$flatNumber: $('#invoice-flat-number'),
			$zipCode: $zipCode
		});

		let $viesButton = $self.find('.js-vies-button');

		vies.init({
			$box: $self.find('.vies-box'),
			$button: $viesButton,
			$vatNumber: $vatUe,
			$taxIdSelector: $taxIdentifierSelector,
			$country: $vatUeCountryCode,
			nipEuValidate: config.nipEuValidate,
			validatedVatUeNumbers: config.validatedVatUeNumbers,
			onVatUeValidationUpdated: triggerVatUeValidation
		});

		// wymuszamy weryfikację VIES dla klienta powracającego
		if ($viesButton.length && !$viesButton.is(':disabled')) {
			triggerVatUeValidation();
			validate.scrollToError();
		}
		if (!isOneInit) {
			isOneInit = true;
			broker.on('VIES_VERIFICATION_FINISHED', function (event, result) {
				if (result.success) {
					updateValidatedVatUeNumbersConfig(result.countryCode, result.vatUeNumber);
				}
				triggerVatUeValidation();
			});

			broker
				.on('DELIVERY_BUYER_TAX_ID_TYPE_CHANGED', handleBuyerTaxIdTypeChanged)
				.on('DELIVERY_FRONT_USER_TYPE_CHANGED', handleBuyerTaxIdTypeChanged);
		}

		function handleBuyerTaxIdTypeChanged() {
			const forcedOtherInvoiceDetails = config.deliveryInfo.containsTelecommunicationRelatedItems
				|| config.deliveryInfo.frontUserType === 'COMPANY'
				&& config.deliveryInfo.withWarranty
				&& (config.deliveryInfo.taxIdType === 'EMPTY_ID' || config.deliveryInfo.taxIdType === 'NUMBER_ID')
				&& !config.deliveryInfo.isAnyProductActivationVoucher;

			config.deliveryInfo.forcedOtherInvoiceDetails = forcedOtherInvoiceDetails;

			if (forcedOtherInvoiceDetails) {
				toggleInvoiceData(true);
				config.deliveryInfo.invoiceNeeded = true;
			}

			render();
		}

		function updateValidatedVatUeNumbersConfig(countryCode, vatUeNumber) {
			if (!config.validatedVatUeNumbers.some(entry => entry[countryCode] && entry[countryCode].includes(vatUeNumber))) {
				config.validatedVatUeNumbers.push({ [countryCode]: [vatUeNumber] });
			}
		}

		function triggerVatUeValidation() {
			validate.element($vatUeCountryCode, $form);
			validate.element($vatUe, $form);
		}
	}

	function toggleInvoiceData(showInvoiceData) {

		if (showInvoiceData) {
			if (config.deliveryInfo.frontUserType === "INDIVIDUAL") {
				config.deliveryInfo.invoiceNeeded = true;
			}
			orderClass.remove('hide-invoice-data');
		} else {
			config.deliveryInfo.invoiceNeeded = false;
			config.deliveryInfo.showAdditionalInvoice = false;
			orderClass.add('hide-invoice-data');
		}
		broker.trigger('DELIVERY_INVOICE_DATA_CHANGED');
		render();
		$('input[type=checkbox].js-toggle-invoice-data-checkbox', $self).prop('checked', config.deliveryInfo.invoiceNeeded);
	}

	function updateTaxPayerRole() {

		$toggleTaxPayerRoleGrv.prop('checked', config.deliveryInfo.taxPayerRoleGrv)
			.prop('disabled', config.deliveryInfo.taxPayerRoleJst)
			.closest('.tax-payer-role')
			.toggleClass('is-disabled', config.deliveryInfo.taxPayerRoleJst);

		$toggleTaxPayerRoleJst.prop('checked', config.deliveryInfo.taxPayerRoleJst)
			.prop('disabled', config.deliveryInfo.taxPayerRoleGrv)
			.closest('.tax-payer-role')
			.toggleClass('is-disabled', config.deliveryInfo.taxPayerRoleGrv);
	}

	function toggleTaxPayerRoleJstChange(checked) {

		config.deliveryInfo.taxPayerRoleJst = checked;

		if (checked) {
			config.deliveryInfo.taxPayerRoleGrv = false;
		}

		broker.trigger('DELIVERY_TAX_PAYER_ROLE_CHANGED');
	}

	function toggleTaxPayerRoleGrvChange(checked) {

		config.deliveryInfo.taxPayerRoleGrv = checked;

		if (checked) {
			config.deliveryInfo.taxPayerRoleJst = false;
		}

		broker.trigger('DELIVERY_TAX_PAYER_ROLE_CHANGED');
	}

	function handleInvoiceAddressCountryChange() {

		const countryCode = $countryCode.val();
		if (countryCode === 'PL') {
			$.cityAutocomplete('#invoice-zip-code', '#invoice-city-name', config.streetValidateEnable ? '#invoice-street' : false);
		} else {
			$.cityUnautocomplete('#invoice-zip-code', '#invoice-city-name', '#invoice-street');
		}

		setZipCode(countryCode);

		if (hasChangedPolishCountryCode($countryCode)) {
			$('#invoice-street, #invoice-house-number, #invoice-flat-number, #invoice-zip-code, #invoice-city-name').val(''); // czyścimy dane adresowe
		}
		$countryCode.data('prev-value', countryCode);
	}

	function setZipCode(countryCode) {

		const isPolishCountryCode = countryCode === 'PL';
		const maxLength = isPolishCountryCode ? 6 : 8;
		const type = isPolishCountryCode ? 'tel' : 'text';
		const placeholder = isPolishCountryCode ? '_ _ - _ _ _' : '';

		$zipCode.filter(':not([type=hidden])').prop({
			'maxlength': maxLength,
			'type': type,
			'placeholder': placeholder
		});
	}

	function hasChangedPolishCountryCode($countryCode) {
		const previousValue = $countryCode.data('prev-value');
		const currentValue = $countryCode.val();

		if (previousValue === 'PL' && currentValue !== 'PL') {
			return true;
		}

		return previousValue !== 'PL' && currentValue === 'PL';
	}

	function onTaxIdentifierChange() {

		select.clear($numberIdCountryCode);
		select.clear($vatUeCountryCode);

		render();
	}

	function render() {

		const invoiceNeeded = config.deliveryInfo.showInvoiceData && config.deliveryInfo.invoiceNeeded;
		const isCompanyUserType = config.deliveryInfo.frontUserType === 'COMPANY';
		const forcedOtherInvoiceDetails = config.deliveryInfo.forcedOtherInvoiceDetails || config.deliveryInfo.withWarranty && config.deliveryInfo.forceReservation;

		orderClass.toggle('hide-invoice-details', !invoiceNeeded);
		orderClass.toggle('hide-invoice-company-box hide-invoice-company-restrictions-message', !isCompanyUserType);
		orderClass.toggle('hide-invoice-individual-user-restrictions-message', isCompanyUserType);
		orderClass.toggle('hide-invoice-name-box', isCompanyUserType);
		orderClass.toggle('hide-invoice-data-controls', forcedOtherInvoiceDetails);
		orderClass.toggle('hide-invoice-details-control', forcedOtherInvoiceDetails || !isCompanyUserType);

		if (invoiceNeeded || forcedOtherInvoiceDetails) {
			orderClass.remove('hide-invoice-data');
		}

		$toggleOtherInvoiceReceiver.prop('checked', invoiceNeeded);

		if (forcedOtherInvoiceDetails) {
			$toggleInvoiceDataOther.prop('checked', true);
		}

		setToggleInvoiceDataUserState(forcedOtherInvoiceDetails);

		setTaxIdTypeBox();
		updateValidation(invoiceNeeded, forcedOtherInvoiceDetails);
		updateTaxPayerRole();

		// czyścimy błędy z backendu
		$('input[name^=invoice]').each(function () {
			validate.removeBackendError($(this));
		});
	}

	function setToggleInvoiceDataUserState(forcedOtherInvoiceDetails) {
		$toggleInvoiceDataUser
			.prop('disabled', forcedOtherInvoiceDetails)
			.attr('tabindex', forcedOtherInvoiceDetails ? '-1' : null)
			.closest('.radio-css')
			.toggleClass('radio-disabled', forcedOtherInvoiceDetails);
	}

	function setTaxIdTypeBox() {
		$taxIdTypeBoxes
			.removeClass('active')
			.filter((i, el) => el.dataset.type === config.deliveryInfo.invoiceTaxIdType)
			.addClass('active');
	}

	function setFieldState($field, shouldBeIgnored) {
		if ($field.hasClass('ignore') !== shouldBeIgnored) {
			$field.ignore(shouldBeIgnored);
		}
	}

	function updateValidation(invoiceNeeded, forcedOtherInvoiceDetails) {

		const isCompany = config.deliveryInfo.frontUserType === 'COMPANY';
		const isIndividual = !isCompany;
		const taxIdType = config.deliveryInfo.invoiceTaxIdType;
		const companyFieldsDisabled = !invoiceNeeded || isIndividual;

		$vatUeCountryCode.prop('disabled', taxIdType !== 'VAT_UE');
		$numberIdCountryCode.prop('disabled', taxIdType !== 'NUMBER_ID');

		setFieldState($toggleInvoiceDataUser, forcedOtherInvoiceDetails);

		setFieldState($userName, !invoiceNeeded || isCompany);
		setFieldState($invoiceAddress, !invoiceNeeded);

		setFieldState($taxIdentifierSelector, companyFieldsDisabled);
		setFieldState($companyName, companyFieldsDisabled);
		setFieldState($nip, companyFieldsDisabled || taxIdType !== 'NIP');
		setFieldState($vatUe, companyFieldsDisabled || taxIdType !== 'VAT_UE');
		setFieldState($vatUeCountryCode, companyFieldsDisabled || taxIdType !== 'VAT_UE');
		setFieldState($idNumber, companyFieldsDisabled || taxIdType !== 'NUMBER_ID');
		setFieldState($numberIdCountryCode, companyFieldsDisabled || taxIdType !== 'NUMBER_ID');
	}

	function switchAddress(address) {
		$('#invoice-firstname').val(address.addLine1);
		$('#invoice-surname').val(address.addLine2);
		$('#invoice-street').val(address.street);
		$('#invoice-house-number').val(address.houseNumber);
		$('#invoice-flat-number').val(address.flatNumber);
		$('#invoice-city-name').val(address.city);
		$('#invoice-company-name-textarea-div').text(address.companyName).trigger('input');
		$('#invoice-id-number-div').text(address.numberId).trigger('input');

		$self.find('.vies-box').removeClass('is-success');
		$self.find('.js-vies-button').prop('disabled', true);

		$zipCode.val(address.zipCode);
		$nip.val(address.nip);
		$vatUe.val(address.vatUe);
		config.deliveryInfo.invoiceTaxIdType = address.companyTaxIdType !== "" ? address.companyTaxIdType : "NIP";
		const countryCode = address.countryCode || "PL";
		select.setValue({ $input: $taxIdentifierSelector, value: config.deliveryInfo.invoiceTaxIdType });

		select.setValue({ $input: $countryCode, value: countryCode });
		$countryCode.data('prev-value', countryCode);
		setZipCode(countryCode);

		if (config.deliveryInfo.invoiceTaxIdType === 'VAT_UE' && address.companyCountryCode) {
			select.setValue({ $input: $vatUeCountryCode, value: address.companyCountryCode });
			$vatUe.trigger('input');
		}

		if (config.deliveryInfo.invoiceTaxIdType === 'NUMBER_ID' && address.companyCountryCode) {
			select.setValue({ $input: $numberIdCountryCode, value: address.companyCountryCode });
		}

		if (config.deliveryInfo.taxPayerRoleJst !== address.taxPayerRoleJst) {
			config.deliveryInfo.taxPayerRoleJst = address.taxPayerRoleJst;
			toggleTaxPayerRoleJstChange(address.taxPayerRoleJst);
		}

		if (config.deliveryInfo.taxPayerRoleGrv !== address.taxPayerRoleGrv) {
			config.deliveryInfo.taxPayerRoleGrv = address.taxPayerRoleGrv;
			toggleTaxPayerRoleGrvChange(address.taxPayerRoleGrv);
		}

		render();
	}

	return {
		init,
		render,
		switchAddress
	};
});
